import { customerWords } from './engine-words';

/**
 * Paige's words for an engine finding shown in the workbench. The engine is CapturePoint's, ported, and
 * its findings are written for a desktop operator: they name the engine's lanes and runtimes ("Template
 * extraction was unavailable; product-shape retry used: The understanding pool could not be reached.",
 * Dustin on a purchase order on prod, 2026-10-05). The engine keeps its text, because the review rules
 * and the finding clearing match on it (finding-clearing.ts, ReviewState.cs); only what is shown changes.
 *
 * Rules first, for findings a customer can act on; then the reader names become Cortexa (engine-words);
 * and a message that still names an internal part after both is replaced whole, so no lane, pool, model,
 * library or vendor name ever reaches the screen whatever a CapturePoint sync brings.
 */
const rules: { match: RegExp; say: string }[] = [
  {
    match: /^Template extraction was unavailable; product-shape retry used:/,
    say: "Cortexa read this document's values a second way after its first reading did not finish. Check the values before you confirm them.",
  },
  {
    match: /NOT READ\. The reading model could not be reached/,
    say: 'Cortexa could not be reached, so this document has not been read yet. Read it again once Cortexa is back.',
  },
];

/** Words a customer must never see: CapturePoint's lanes, Paige's pools, the models and the libraries. */
const INTERNAL =
  /\b(template extraction|product-shape|understanding pool|OCR pool|reasoner|reading model|reading runtime|runtime|Granite|Bonsai|Qwen|vLLM|llama|GLiNER|TableFormer|Triton|RapidOCR|PaddleOCR|PP-OCR|HttpClient|GPU|CUDA)\b/i;

const GENERIC =
  'Cortexa flagged this document for a check. Look over its values before you confirm them.';

export function findingWords(message: string | null | undefined): string {
  if (!message) return '';
  const rule = rules.find((candidate) => candidate.match.test(message));
  if (rule) return rule.say;
  const said = customerWords(message);
  return INTERNAL.test(said) ? GENERIC : said;
}
